import {
    Component,
    HostListener,
    forwardRef,
    Input,
    Output,
    EventEmitter,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    ElementRef,
} from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";
import { ListItem } from "../models/ListItem";
import { FacilitatorSearchComponent } from "../facilitator-search/facilitator-search.component";

export interface DropdownSettings {
    singleSelection: boolean;
    idField?: string;
    textField?: string;
    enableCheckAll: boolean;
    selectAllText?: string;
    unSelectAllText?: string;
    allowSearchFilter?: boolean;
    clearSearchFilter?: boolean;
    maxHeight?: number;
    itemsShowLimit?: number;
    limitSelection?: number;
    searchPlaceholderText?: string;
    closeDropDownOnSelection?: boolean;
    optionsShowLimit?: number;
}

export const DROPDOWN_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgMultiselectDropdownDirective),
    multi: true,
};
const noop = () => { };

@Component({
    selector: "app-ng-multiselect-dropdown",
    templateUrl: "./views/multi-select.component.html",
    //styleUrls: ['./multi-select.component.scss'],
    providers: [DROPDOWN_CONTROL_VALUE_ACCESSOR],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NgMultiselectDropdownDirective implements ControlValueAccessor {
    public _settings: DropdownSettings;
    public _data: Array<ListItem> = [];
    public selectedItems: Array<ListItem> = [];
    public totalItemsCount: any;
    public isDropdownOpen = false;
    _placeholder: string = "Select";
    _placeholderback: string = "";
    _placeholderWidth:string='none';
    _allplaceholder: string = "All selection";
    _defaultPlaceHolder: string = "";
    filter: ListItem = new ListItem(this.data);
    defaultSettings: DropdownSettings = {
        singleSelection: false,
        idField: "id",
        textField: "text",
        enableCheckAll: true,
        selectAllText: "Select All",
        unSelectAllText: "UnSelect All",
        allowSearchFilter: false,
        limitSelection: -1,
        clearSearchFilter: true,
        maxHeight: 197,
        itemsShowLimit: 999999999999,
        searchPlaceholderText: "Search",
        closeDropDownOnSelection: false,
        optionsShowLimit: 999999999999,
    };

    @Input()
    public set placeholder(value: string) {
        if (value) {
            this._placeholder = value;
            this._defaultPlaceHolder = value;
            this._allplaceholder = value;
        } else {
            this._placeholder = "Select";
            this._defaultPlaceHolder = "Select";
            this._allplaceholder = "All selection";
        }
    }
    @Input() disabled = false;
    @Input() disabledropdown = false;
    @Input()
    public set settings(value: any) {
        if (value) {
            this._settings = Object.assign(this.defaultSettings, value);
        } else {
            this._settings = Object.assign(this.defaultSettings);
        }
    }

    @Input()
    public set data(value: Array<any>) {
        if (!value) {
            this._data = [];
        } else {
            const _items = value.filter((item: any) => {
                if (
                    typeof item === "string" ||
                    (typeof item === "object" &&
                        item &&
                        item[this._settings.idField] &&
                        item[this._settings.textField])
                ) {
                    return item;
                }
            });
            this._data = _items.map((item: any) =>
                typeof item === "string"
                    ? new ListItem(item)
                    : new ListItem({
                        id: item[this._settings.idField],
                        text: item[this._settings.textField],
                    })
            );
            //this._data.forEach(item => {
            //  this.selectedItems.push(item)
            //})

            this.totalItemsCount = this._data.length;
        }
    }

    @Output("onFilterChange") onFilterChange: EventEmitter<ListItem> =
        new EventEmitter<any>();

    @Output("onSelect") onSelect: EventEmitter<any> = new EventEmitter<any>();

    @Output("onDeSelect") onDeSelect: EventEmitter<ListItem> =
        new EventEmitter<any>();

    @Output("onSelectAll") onSelectAll: EventEmitter<Array<ListItem>> =
        new EventEmitter<Array<any>>();

    @Output("onDeSelectAll") onDeSelectAll: EventEmitter<Array<ListItem>> =
        new EventEmitter<Array<any>>();

    @Output("onApplyClick") onApplyClick: EventEmitter<any> =
        new EventEmitter<any>();

    @Output("onCancelClick") onCancelClick: EventEmitter<any> =
        new EventEmitter<any>();

    @Output() onDropdownClose: EventEmitter<void> = new EventEmitter<void>();

    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    onFilterTextChange($event) {
        this.onFilterChange.emit($event);
    }
    filterapplieditems = [];
    uncheckAll() {
        //this.closeMyDropDown();
        // this.closeDropdown();
        var _this = this;
        this.selectedItems = [];
        this.setPlaceHolder();
        this._element.nativeElement.querySelector("ul.dropdown-menu").scrollTop = 0;
        this._data.forEach((item) => {
            this.selectedItems.push(item);
        });
        this.totalItemsCount = this.selectedItems.length;
        this.filterapplieditems = [];
        this.onCancelClick.emit(this.selectedItems);
    }

    btnApply() {
        //console.log("btnapply",this.selectedItems);
        //this.closeDropdown();
        this.filterapplieditems = [];
        if (this.selectedItems.length != 0) {
            this.selectedItems.forEach((item) => {
                this.filterapplieditems.push(item);
            });
            //this._element.nativeElement.querySelector('ul.dropdown-menu').scrollTop = 0
            //this.onApplyClick.emit(this.filterapplieditems);
        }
        //else {
        //  this._data.forEach(item => {
        //    this.selectedItems.push(item);
        //  })
        //  this._element.nativeElement.querySelector('ul.dropdown-menu').scrollTop = 0
        //  this.onApplyClick.emit(this.filterapplieditems);
        //}
    }

    constructor(private cdr: ChangeDetectorRef, private _element: ElementRef, private FacilitatorChild: FacilitatorSearchComponent) { }

    onItemClick($event: any, item: ListItem) {
        $event.stopPropagation();
        //$event.preventDefault();
        if (this.disabled) {
            return false;
        }

        const found = this.isSelected(item);
        const allowAdd =
            this._settings.limitSelection === -1 ||
            (this._settings.limitSelection > 0 &&
                this.selectedItems.length < this._settings.limitSelection);
        if (!found) {
            if (allowAdd) {
                this.addSelected(item);
            }
        } else {
            this.removeSelected(item);
        }
        //this._element.nativeElement.querySelector('ul.dropdown-menu').scrollTop = 0
        var data = {
            item: item,
            isChecked:
                $event.target.tagName == "SPAN"
                    ? $event.target.previousElementSibling.checked
                        ? false
                        : true
                    : $event.target.checked,
            selectAll: false,
        };
        this.onSelect.emit(data);

        //console.log("selectedItems", this.selectedItems);
        this.setPlaceHolder();
        return true;
    }

    setPlaceHolder() {
        //console.log("set placeholder function",this.selectedItems);
        if (this.selectedItems.length == 1) {
            this._placeholderback = "";
            if(this.selectedItems[0].text.toString().length > 25 && this._placeholderback != ""){   
                this._placeholder = this.selectedItems[0].text.toString().substring(0, 25) + '...'; 
            }else{
                this._placeholder = this.selectedItems[0].text.toString();
            }         
            this._placeholderWidth = 'none';
        } else if (
            this.selectedItems.length > 1 &&
            this.selectedItems.length < this.totalItemsCount
        ) {
            //this._placeholder = 'MULTIPLE';
            const count = this.selectedItems.length - 1;
            this._placeholderWidth = (this._element.nativeElement.querySelector("div.inputValFontSizeLineHeight").offsetWidth - 87).toString() + 'px';
                this._placeholderback = "and " + count + " more";    
                if(this.selectedItems[0].text.toString().length > 25 && this._placeholderback != ""){
                        this._placeholder = this.selectedItems[0].text.toString().substring(0, 25) + '...'; 
                    }else{
                        this._placeholder = this.selectedItems[0].text.toString();
                    }          
                this._placeholderWidth = 'none';
           
        } else if (this.selectedItems.length == 0) {
            this._placeholder = "Select";
            this._placeholderback = "";
            this._placeholderWidth = 'none';
        } else if (this.selectedItems.length == this._data.length) {
            //newly added condition
            //this._placeholder = this._defaultPlaceHolder;
            this._placeholder = "All";
            this._placeholderback = "";
            this._placeholderWidth = 'none';
        } else {
            console.log("");
        }
    }
    resetPlaceHolder(type?: any) {
        //console.log(type);
        setTimeout(() => {

            this.selectedItems = [];
            if (type == "state") {
                var data = this.FacilitatorChild.updatedStateDataList;
                for (var j = 0; j < data.length; j++) {
                    const value_new = new ListItem({
                        id: data[j][0]['ID'],
                        text: data[j][0]['Name']
                    });
                    this.selectedItems.push(value_new);
                }
            }
            else if (type == 'city') {
                var data = this.FacilitatorChild.updatedCityDataList;
                for (var j = 0; j < data.length; j++) {
                    const value_new = new ListItem({
                        id: data[j][0]['CityID'],
                        text: data[j][0]['CityName']
                    });
                    this.selectedItems.push(value_new);
                }
            }
            else if (type == 'function') {
                var data = this.FacilitatorChild.updatedFunctionDataList;
                for (var j = 0; j < data.length; j++) {
                    const value_new = new ListItem({
                        id: data[j][0]['ID'],
                        text: data[j][0]['Name']
                    });
                    this.selectedItems.push(value_new);
                }
            }
            else if (type == 'service') {
                var data = this.FacilitatorChild.updatedServiceDataList;
                for (var j = 0; j < data.length; j++) {
                    const value_new = new ListItem({
                        id: data[j][0]['ServiceAreaID'],
                        text: data[j][0]['ServiceAreaName']
                    });
                    this.selectedItems.push(value_new);
                }
            }
            else if (type == 'industry') {
                var data = this.FacilitatorChild.updatedIndustryDataList;
                for (var j = 0; j < data.length; j++) {
                    const value_new = new ListItem({
                        id: data[j][0]['ID'],
                        text: data[j][0]['Name']
                    });
                    this.selectedItems.push(value_new);
                }
            }
            else if (type == 'sector') {
                var data = this.FacilitatorChild.updatedSectorDataList;
                for (var j = 0; j < data.length; j++) {
                    const value_new = new ListItem({
                        id: data[j][0]['SectorID'],
                        text: data[j][0]['SectorName']
                    });
                    this.selectedItems.push(value_new);
                }
            }
            else {
                console.log("");
            }
            this.setPlaceHolder();
        }, 1000);
    }
    writeValue(value: any) {
        //console.log("value", value);
        if (value !== undefined && value !== null && value.length > 0) {
            if (this._settings.singleSelection) {
                try {
                    if (value.length >= 1) {
                        const firstItem = value[0];
                        this.selectedItems = [
                            typeof firstItem === "string"
                                ? new ListItem(firstItem)
                                : new ListItem({
                                    id: firstItem[this._settings.idField],
                                    text: firstItem[this._settings.textField],
                                }),
                        ];
                    }
                } catch (e) {
                    // console.error(e.body.msg);
                }
            } else {
                //console.log("value1 persist", typeof (value));
                if (
                    typeof value == "object" &&
                    (value[0].Name != undefined ||
                        value[0].CityName != undefined ||
                        value[0].ServiceAreaName != undefined ||
                        value[0].SectorName != undefined ||
                        value[0].SessionFormatName != undefined ||
                        value[0].SessionsRange != undefined)
                ) {
                    //console.log("object h");

                    /* console.log(this._data);
                       value = this._data.filter(data => data.id == value);
                       console.log("value2", value);
                       let value_new =
               
                           new ListItem({
                               ID: value[0].id,
                               Name: value[0].text
                           });
               
                       console.log("value_new", value_new);*/

                    const _data = value.map((item: any) =>
                        typeof item === "string"
                            ? new ListItem(item)
                            : new ListItem({
                                id: item[this._settings.idField],
                                text: item[this._settings.textField],
                            })
                    );
                    // console.log("Data", _data);
                    if (this._settings.limitSelection > 0) {
                        //console.log("inside if");
                        this.selectedItems = _data.splice(0, this._settings.limitSelection);
                    } else {
                        //console.log("else");
                        this.selectedItems = _data;
                    }
                }
            }
            // console.log("selectedItems", this.selectedItems);
        } else {
            this.selectedItems = [];
        }
        this.onChangeCallback(value);
    }

    // From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    // From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    // Set touched on blur
    @HostListener("blur")
    public onTouched() {
        this.closeDropdown();
        this.onTouchedCallback();
    }

    trackByFn(index, item) {
        return item.id;
    }

    isSelected(clickedItem: ListItem) {
        let found = false;
        this.selectedItems.forEach((item) => {
            if (clickedItem.id === item.id) {
                found = true;
            }
        });

        return found;
    }

    isLimitSelectionReached(): boolean {
        return this._settings.limitSelection === this.selectedItems.length;
    }

    isAllItemsSelected(): boolean {
        return this._data.length === this.selectedItems.length;
    }

    showButton(): boolean {
        if (!this._settings.singleSelection) {
            if (this._settings.limitSelection > 0) {
                return false;
            }
            // this._settings.enableCheckAll = this._settings.limitSelection === -1 ? true : false;
            return true; // !this._settings.singleSelection && this._settings.enableCheckAll && this._data.length > 0;
        } else {
            // should be disabled in single selection mode
            return false;
        }
    }

    itemShowRemaining(): number {
        return this.selectedItems.length - this._settings.itemsShowLimit;
    }

    addSelected(item: ListItem) {
        if (this._settings.singleSelection) {
            this.selectedItems = [];
            this.selectedItems.push(item);
        } else {
            this.selectedItems.push(item);
        }
        //this.onChangeCallback(this.emittedValue(this.selectedItems));
        // this.onSelect.emit(this.emittedValue(item));
    }

    removeSelected(itemSel: ListItem) {
        this.selectedItems.forEach((item) => {
            if (itemSel.id === item.id) {
                this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
            }
        });
        //  this.onChangeCallback(this.emittedValue(this.selectedItems));
        // this.onDeSelect.emit(this.emittedValue(itemSel));
    }

    emittedValue(val: any): any {
        const selected = [];
        if (Array.isArray(val)) {
            val.map((item) => {
                if (item.id === item.text) {
                    selected.push(item.text);
                } else {
                    selected.push(this.objectify(item));
                }
            });
        } else {
            if (val) {
                if (val.id === val.text) {
                    return val.text;
                } else {
                    return this.objectify(val);
                }
            }
        }
        return selected;
    }

    objectify(val: ListItem) {
        const obj = {};
        obj[this._settings.idField] = val.id;
        obj[this._settings.textField] = val.text;
        return obj;
    }


    toggleDropdown(evt) {

        // evt.stopPropagation();

         evt.preventDefault();

        if (!this.disabledropdown) {
            //console.log(this._element);
            if (this.disabled && this._settings.singleSelection) {
                return;
            }
            this.isDropdownOpen = !this.isDropdownOpen;
            this._element.nativeElement.querySelector(
                "ul.dropdown-menu"
            ).scrollTop = 0;
        }
        //  this.closeMyDropDown();
    }

    closeMyDropDown() {
        if (
            !this._element.nativeElement
                .querySelector("ul.dropdown-menu")
                .classList.contains("open-success")
        ) {
            this._element.nativeElement
                .querySelector("ul.dropdown-menu")
                .classList.add("open-success");
        } else {
            this._element.nativeElement
                .querySelector("ul.dropdown-menu")
                .classList.remove("open-success");
        }
    }
    closeDropdown() {
        this.isDropdownOpen = false;
        // clear search text
        if (this._settings.clearSearchFilter) {
            this.filter.text = "";
        }
        this.onDropdownClose.next();
    }
    outclick() {
        //console.log("click outside", this.selectedItems);
        this.isDropdownOpen = false;
        //if (this._settings.clearSearchFilter) {
        //  this.filter.text = "";
        //}
        //let selecteditems: any = [];
        //for (let item of this.selectedItems) {
        //  selecteditems.push(item);
        //}
        //if (this.filterapplieditems.length > 0) {
        //  //console.log('filtered items ' + this.filterapplieditems)
        //  this.filterapplieditems.forEach((item) => {
        //    if (this.selectedItems.indexOf(item) == -1) {
        //      this.addSelected(item);
        //    }
        //  });
        //  selecteditems.forEach((item) => {
        //    if (this.filterapplieditems.indexOf(item) == -1) {
        //      this.removeSelected(item);
        //    }
        //  });
        //} else {
        //  //this.selectedItems = [];
        //  //this._data.forEach(item => {
        //  //  this.selectedItems.push(item)
        //  //})
        //}
        // console.log("this.selectedItems", this.selectedItems)
        this.setPlaceHolder();
        this._element.nativeElement.querySelector("ul.dropdown-menu").scrollTop = 0;
    }

    toggleSelectAll() {
        if (this.disabled) {
            return false;
        }
        if (!this.isAllItemsSelected()) {
            this.selectedItems = this._data.slice();
            this.onSelectAll.emit(this.emittedValue(this.selectedItems));
        } else {
            this.selectedItems = [];
            this.onDeSelectAll.emit(this.emittedValue(this.selectedItems));
        }
        this.onChangeCallback(this.emittedValue(this.selectedItems));
        this.setPlaceHolder();
        return true;
    }
}
